import { Link } from "react-router-dom";
import { allGenres, allMovies } from "@/lib/movies";
import { formatViews } from "@/lib/movies";

export default function SidebarPanel() {
  const hot = [...allMovies].sort((a, b) => b.views - a.views).slice(0, 6);
  const genres = allGenres.slice(0, 10);

  return (
    <aside className="flex flex-col gap-6">
      <section className="rounded-lg border border-background-200/70 bg-background-100/60 p-4 md:p-5">
        <div className="flex items-center justify-between mb-3.5">
          <h3 className="font-heading text-base font-semibold text-foreground-50">分类导航</h3>
          <i className="ri-compass-3-line text-foreground-600"></i>
        </div>
        <div className="flex flex-wrap gap-2">
          {genres.map((genre) => (
            <Link
              key={genre}
              to={`/category?genre=${encodeURIComponent(genre)}`}
              className="px-2.5 py-1.5 rounded-md bg-background-200/60 text-xs text-foreground-300 hover:bg-primary-500 hover:text-foreground-50 transition-colors cursor-pointer"
            >
              {genre}
            </Link>
          ))}
        </div>
        <div className="mt-4 grid grid-cols-2 gap-2">
          <Link
            to="/category?type=电影"
            className="h-9 rounded-md border border-background-300/70 text-xs text-foreground-300 flex items-center justify-center gap-1 hover:border-accent-500 hover:text-accent-500 transition-colors cursor-pointer"
          >
            <i className="ri-film-line"></i>电影
          </Link>
          <Link
            to="/category?type=剧集"
            className="h-9 rounded-md border border-background-300/70 text-xs text-foreground-300 flex items-center justify-center gap-1 hover:border-accent-500 hover:text-accent-500 transition-colors cursor-pointer"
          >
            <i className="ri-live-line"></i>剧集
          </Link>
        </div>
      </section>

      <section className="rounded-lg border border-background-200/70 bg-background-100/60 p-4 md:p-5">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading text-base font-semibold text-foreground-50">热门推荐</h3>
          <span className="font-label text-[10px] tracking-[0.24em] text-foreground-600">
            TRENDING
          </span>
        </div>
        <ol className="flex flex-col gap-3.5">
          {hot.map((movie, index) => (
            <li key={movie.id}>
              <Link
                to={`/detail/${movie.id}`}
                className="group flex gap-3 items-start cursor-pointer"
              >
                <span
                  className={`font-label text-lg leading-none w-6 shrink-0 pt-0.5 ${
                    index < 3 ? "text-accent-500" : "text-foreground-700"
                  }`}
                >
                  {String(index + 1).padStart(2, "0")}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block text-sm text-foreground-200 group-hover:text-accent-500 transition-colors truncate">
                    {movie.title}
                  </span>
                  <span className="mt-1 flex items-center gap-2 text-[11px] text-foreground-600">
                    <span>{movie.type}</span>
                    <span className="w-0.5 h-0.5 rounded-full bg-foreground-700"></span>
                    <span>{movie.year}</span>
                    <span className="w-0.5 h-0.5 rounded-full bg-foreground-700"></span>
                    <span>{formatViews(movie.views)}</span>
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </section>

      <section className="rounded-lg border border-primary-300/40 bg-primary-500/10 p-4 md:p-5">
        <div className="flex items-center gap-2 mb-2.5">
          <i className="ri-quill-pen-line text-accent-500"></i>
          <h3 className="font-heading text-base font-semibold text-foreground-50">
            关于剧情解析
          </h3>
        </div>
        <p className="text-xs leading-relaxed text-foreground-400">
          我们不做剧透式简介，而是把人物动机、叙事结构与关键线索拆开讲清楚。适合看完之后想再想一遍的人。
        </p>
        <Link
          to="/about"
          className="mt-3.5 inline-flex items-center gap-1 text-xs text-accent-500 hover:text-accent-400 transition-colors cursor-pointer"
        >
          了解我们的编辑原则
          <i className="ri-arrow-right-line"></i>
        </Link>
      </section>
    </aside>
  );
}